import { projectClient } from '../../client/client';
import * as ext from './z3-ext';

export const z3 = {
  listBuckets: projectClient('/z3').get,
  createBucket: projectClient('/z3/{bucketName}').put,
  deleteBucket: projectClient('/z3/{bucketName}').delete,
  listObjects: projectClient('/z3/{bucketName}/{objectPath+}').get,
  getPresignedUrl: projectClient('/z3/{bucketName}/{objectPath+}').post,
  deleteObject: projectClient('/z3/{bucketName}/{objectPath+}').delete,
  ...ext,
};
